import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AsianPaintsRoutingModule } from './asian-paints-routing.module';
import { SharedModule } from '../shared/shared.module';
import { MatTabsModule } from '@angular/material/tabs';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatInputModule } from '@angular/material/input';
import { MatCardModule } from '@angular/material/card';
import { ReactiveFormsModule } from '@angular/forms';
import { AsianPaintsComponent } from './asian-paints.component';
import { AsianPaintsService } from './asian-paints.service';
import { LearningPlayerCoreModule } from '../talent-litmus-core/learning-player-core/learning-player-core.module';

@NgModule({
  declarations: [AsianPaintsComponent],
  imports: [
    CommonModule,
    SharedModule,
    MatTabsModule,
    MatFormFieldModule,
    MatInputModule,
    MatCardModule,
    LearningPlayerCoreModule,
    ReactiveFormsModule,
    AsianPaintsRoutingModule,
  ],
  providers: [AsianPaintsService],
})
export class AsianPaintsModule {}
